import { useState } from 'react';
import {
  loadAdminDocuments,
  saveAdminDocuments,
} from '../../adminDocuments';

export default function useDocumentsAdmin() {
  const [documents, setDocuments] = useState(
    loadAdminDocuments()
  );
  const [documentsStatus, setDocumentsStatus] =
    useState('');

  function handleDocumentUpload(event) {
    const file = event.target.files?.[0];

    if (!file) return;

    setDocumentsStatus('');

    const maxBytes = 2 * 1024 * 1024;

    if (file.size > maxBytes) {
      setDocumentsStatus(
        'Document too large. Please upload a file under 2 MB.'
      );
      event.target.value = '';
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const dataUrl =
        typeof reader.result === 'string'
          ? reader.result
          : '';

      if (!dataUrl) {
        setDocumentsStatus(
          'Could not read selected file.'
        );
        return;
      }

      try {
        const nextDocuments = [
          {
            id: `${Date.now()}_${Math.random()
              .toString(36)
              .slice(2, 8)}`,
            name: file.name,
            mimeType:
              file.type || 'application/octet-stream',
            size: file.size,
            uploadedAt: new Date().toISOString(),
            dataUrl,
          },
          ...documents,
        ];

        const savedDocuments =
          saveAdminDocuments(nextDocuments);

        setDocuments(savedDocuments);
        setDocumentsStatus(
          'Document uploaded successfully.'
        );
      } catch (_error) {
        setDocumentsStatus(
          'Could not save document. Storage may be full.'
        );
      }
    };

    reader.onerror = () => {
      setDocumentsStatus(
        'Could not read selected file.'
      );
    };

    reader.readAsDataURL(file);
    event.target.value = '';
  }

  function handleDeleteDocument(documentId) {
    const nextDocuments = documents.filter(
      (document) => document.id !== documentId
    );

    const savedDocuments =
      saveAdminDocuments(nextDocuments);

    setDocuments(savedDocuments);
    setDocumentsStatus('Document removed.');
  }

  function handlePrintDocument(document) {
    const printWindow = window.open(
      document.dataUrl,
      '_blank',
      'noopener,noreferrer'
    );

    if (!printWindow) {
      setDocumentsStatus(
        'Could not open print preview. Please allow pop-ups and try again.'
      );
      return;
    }

    printWindow.focus();

    setTimeout(() => {
      try {
        printWindow.print();
      } catch (_error) {
        setDocumentsStatus(
          'Print preview opened. Use your browser print command if needed.'
        );
      }
    }, 500);
  }

  return {
    documents,
    documentsStatus,
    handleDocumentUpload,
    handleDeleteDocument,
    handlePrintDocument,
  };
}